import { useAppSelector } from "redux/hooks";
import { getUsersData } from "redux/slices/usersSlice";

type RowObj = {
  name: string;
  progress: string;
  quantity: number;
  date: string;
};

const useUsersTableData = () => {
  return useAppSelector(getUsersData);
};

export default useUsersTableData;
